import { render, staticRenderFns } from "./SitePageResults.vue?vue&type=template&id=186be478&"
import script from "./SitePageResults.vue?vue&type=script&lang=js&"
export * from "./SitePageResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports